"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9255],{

/***/ 67653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var _hooks_useDelayedUnmount__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99421);
/* harmony import */ var _hooks_useMatchBreakpoints__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70589);
/* harmony import */ var _hooks_useOnClickOutside__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33750);
/* harmony import */ var _util_getPortalRoot__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77382);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7180);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5527);
/* harmony import */ var _Overlay__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73156);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92510);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49265);












var BottomDrawer = function BottomDrawer(param) {
    var content = param.content, isOpen = param.isOpen, setIsOpen = param.setIsOpen;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var shouldRender = (0,_hooks_useDelayedUnmount__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(isOpen, 350);
    var isMobile = (0,_hooks_useMatchBreakpoints__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().isMobile;
    (0,_hooks_useOnClickOutside__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ref === null || ref === void 0 ? void 0 : ref.current, (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return setIsOpen(false);
    }, [
        setIsOpen
    ]));
    if (!shouldRender || !isMobile) {
        return null;
    }
    var portal = (0,_util_getPortalRoot__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    if (portal) return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Overlay__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isUnmounting: !isOpen
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_8__/* .DrawerContainer */ .qt, {
                ref: ref,
                isUnmounting: !isOpen,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        position: "absolute",
                        right: "16px",
                        top: "0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            variant: "text",
                            onClick: function onClick() {
                                return setIsOpen(false);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                        })
                    }),
                    content
                ]
            })
        ]
    }), portal);
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (BottomDrawer);


/***/ }),

/***/ 92863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16 17.01V11c0-.55-.45-1-1-1s-1 .45-1 1v6.01h-1.79c-.45 0-.67.54-.35.85l2.79 2.78c.2.19.51.19.71 0l2.79-2.78c.32-.31.09-.85-.35-.85H16zM8.65 3.35L5.86 6.14c-.32.31-.1.85.35.85H8V13c0 .55.45 1 1 1s1-.45 1-1V6.99h1.79c.45 0 .67-.54.35-.85L9.35 3.35a.501.501 0 00-.7 0z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 19729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 6V7.79C12 8.24 12.54 8.46 12.85 8.14L15.64 5.35C15.84 5.15 15.84 4.84 15.64 4.64L12.85 1.85C12.54 1.54 12 1.76 12 2.21V4C7.58 4 4 7.58 4 12C4 13.04 4.2 14.04 4.57 14.95C4.84 15.62 5.7 15.8 6.21 15.29C6.48 15.02 6.59 14.61 6.44 14.25C6.15 13.56 6 12.79 6 12C6 8.69 8.69 6 12 6ZM17.79 8.71C17.52 8.98 17.41 9.4 17.56 9.75C17.84 10.45 18 11.21 18 12C18 15.31 15.31 18 12 18V16.21C12 15.76 11.46 15.54 11.15 15.86L8.36 18.65C8.16 18.85 8.16 19.16 8.36 19.36L11.15 22.15C11.46 22.46 12 22.24 12 21.8V20C16.42 20 20 16.42 20 12C20 10.96 19.8 9.96 19.43 9.05C19.16 8.38 18.3 8.2 17.79 8.71Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 90105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 25 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M20.497 4.6l-.004-.028-.006-.036-.008-.033-.007-.03-.012-.032-.01-.03-.014-.028-.014-.03-.016-.027-.018-.03-.021-.028-.018-.024a.663.663 0 00-.044-.048v-.001a.66.66 0 00-.049-.044l-.024-.018-.028-.02-.03-.018-.026-.016-.03-.015c-.01-.004-.02-.01-.03-.013l-.03-.011-.03-.011-.031-.008-.033-.008-.035-.005-.03-.005A.684.684 0 0019.834 4h-4.667a.667.667 0 100 1.333h3.057l-4.862 4.862a.667.667 0 10.943.943l4.862-4.862v3.057a.667.667 0 101.333 0V4.667a.658.658 0 00-.003-.066zM10.696 12.861l-4.862 4.862v-3.057a.667.667 0 10-1.333 0v4.667l.003.066.005.029.005.035.008.033.008.03.01.032.012.03.013.029.015.03.016.027.017.029.021.028.018.024a.663.663 0 00.093.093l.024.018.029.021.029.018.026.016.03.014.03.014.03.01.031.012.03.007.033.008.036.006.029.004a.657.657 0 00.066.003h4.666a.667.667 0 000-1.333H6.777l4.862-4.862a.667.667 0 00-.943-.943z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 40212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 23 21"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M17.553 3.091v.001c0 .55.19 1.081.541 1.502l-3.68 7.364a2.346 2.346 0 00-.827.108L10.833 8.97c.14-.3.217-.63.22-.967h0v-.003a2.35 2.35 0 00-2.35-2.35 2.35 2.35 0 00-2.35 2.35V8c.004.499.165.984.465 1.384l-3.477 6.082A2.35 2.35 0 00.75 17.803a2.35 2.35 0 002.35 2.35 2.35 2.35 0 002.35-2.35V17.8a2.338 2.338 0 00-.464-1.384l3.472-6.081c.322.037.65.004.957-.098l2.751 3.096a2.38 2.38 0 00-.216.967v.002a2.352 2.352 0 002.34 2.36 2.352 2.352 0 002.36-2.342v0c0-.55-.19-1.086-.54-1.51l3.68-7.365A2.35 2.35 0 0022.25 3.1a2.347 2.347 0 00-4.697-.01z",
            stroke: "currentColor",
            strokeWidth: 0.5
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 84482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 25 25"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12.327 13.27c0-.01-.003-.019-.004-.028l-.005-.036-.009-.033-.007-.03-.011-.032-.011-.03-.014-.028-.014-.03c-.005-.01-.01-.019-.016-.027l-.018-.03-.021-.028-.018-.024a.692.692 0 00-.044-.049.674.674 0 00-.049-.044l-.024-.018-.028-.02-.03-.018-.026-.016-.03-.015c-.01-.005-.02-.01-.03-.013l-.03-.011-.03-.011-.031-.008-.033-.008-.035-.006-.03-.004a.689.689 0 00-.065-.003H6.997a.667.667 0 000 1.333h3.057l-4.862 4.862a.667.667 0 10.943.943l4.862-4.862v3.057a.667.667 0 001.333 0v-4.666a.689.689 0 00-.003-.066zM19.862 4.195L15 9.057V6a.667.667 0 10-1.333 0v4.667c0 .022.001.044.003.065l.005.03.005.035.008.033.008.03.01.032.012.03.013.029.015.03.016.027.017.029.021.028.018.024a.692.692 0 00.093.093l.024.018.028.021.03.018.027.015.03.015.029.014.03.01.031.012.03.007.033.008.036.006.029.004a.688.688 0 00.066.003H19A.667.667 0 0019 10h-3.057l4.862-4.862a.667.667 0 00-.943-.943z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 29973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 25"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.86 4.86003L21.65 7.65003C21.84 7.84003 21.84 8.16003 21.64 8.35003L18.85 11.14C18.54 11.46 18 11.24 18 10.79V9.00003H4C3.45 9.00003 3 8.55003 3 8.00003C3 7.45003 3.45 7.00003 4 7.00003H18V5.21003C18 4.76003 18.54 4.54003 18.86 4.86003ZM5.14001 19.14L2.35001 16.35C2.16001 16.16 2.16001 15.84 2.36001 15.65L5.15001 12.86C5.46001 12.54 6.00001 12.76 6.00001 13.21V15H20C20.55 15 21 15.45 21 16C21 16.55 20.55 17 20 17H6.00001V18.79C6.00001 19.24 5.46001 19.46 5.14001 19.14Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 99421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Use this hook when you want to animate something when it appears on the screen (e.g. when some prop set to true)
 * but when its not on the screen you want it to be fully unmounted and not just hidden or height 0.
 * This is especially useful when you have a table of 100s rows and each row has expandable element that appears on click.
 * If you just set the expanding animation while keeping inactive elements mounted all those 100 elements will load the DOM,
 * and if they all receive updates via props you're looking at 100 DOM updates for hidden elements.
 * This hook "shows" element immediately when the isMounted is true
 * but keeps element mounted for delayTime to let unmounting animation happen, after which you unmount element completely.
 * delayTime should be the same as animation time in most cases.
 */ var useDelayedUnmount = function useDelayedUnmount(isMounted, delayTime) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), shouldRender = ref[0], setShouldRender = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var timeoutId;
        if (isMounted && !shouldRender) {
            setShouldRender(true);
        } else if (!isMounted && shouldRender) {
            timeoutId = setTimeout(function() {
                return setShouldRender(false);
            }, delayTime);
        }
        return function() {
            return clearTimeout(timeoutId);
        };
    }, [
        isMounted,
        delayTime,
        shouldRender
    ]);
    return shouldRender;
};
/* harmony default export */ __webpack_exports__["Z"] = (useDelayedUnmount);


/***/ }),

/***/ 19131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90452);
/* harmony import */ var components_SearchModal_ImportToken__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9189);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99150);




var ImportTokenWarningModal = function(param) {
    var tokens = param.tokens, onDismiss = param.onDismiss, onCancel = param.onCancel;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: t("Import Token"),
        onDismiss: function() {
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
            onCancel();
        },
        style: {
            maxWidth: "420px"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SearchModal_ImportToken__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            tokens: tokens,
            handleCurrencySelect: onDismiss
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImportTokenWarningModal);


/***/ }),

/***/ 40508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ FlexGap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4318);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  & > * {\n    min-width: 280px;\n    max-width: 31.5%;\n    width: 100%;\n    margin: 0 8px;\n    margin-bottom: 32px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  gap: ",
        ";\n  row-gap: ",
        ";\n  column-gap: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var FlexLayout = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e479e0f6-0"
})(_templateObject());
var FlexGap = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e479e0f6-1"
})(_templateObject1(), function(param) {
    var gap = param.gap;
    return gap;
}, function(param) {
    var rowGap = param.rowGap;
    return rowGap;
}, function(param) {
    var columnGap = param.columnGap;
    return columnGap;
});
/* harmony default export */ __webpack_exports__["Z"] = (FlexLayout);


/***/ }),

/***/ 98438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84091);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56245);
/* harmony import */ var _Layout_Flex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40508);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 32px;\n  line-height: 1.1;\n\n  ",
        " {\n    font-size: 40px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var formatOptions = {
    notation: "standard",
    displayThreshold: 0.001,
    tokenPrecision: true
};
var TextLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-28598359-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var PairPriceDisplay = function(_param) {
    var value = _param.value, inputSymbol = _param.inputSymbol, outputSymbol = _param.outputSymbol, children = _param.children, _format = _param.format, format = _format === void 0 ? true : _format, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "value",
        "inputSymbol",
        "outputSymbol",
        "children",
        "format"
    ]);
    return value ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Flex__WEBPACK_IMPORTED_MODULE_3__/* .FlexGap */ .O, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        alignItems: "baseline"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                alignItems: "inherit",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TextLabel, {
                        mr: "8px",
                        bold: true,
                        children: format ? (0,utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_2__/* .formatAmount */ .d)(typeof value === "string" ? parseFloat(value) : value, formatOptions) : value
                    }),
                    inputSymbol && outputSymbol && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        color: "textSubtle",
                        fontSize: "20px",
                        bold: true,
                        lineHeight: 1.1,
                        children: "".concat(inputSymbol, "/").concat(outputSymbol)
                    })
                ]
            }),
            children
        ]
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        height: "36px",
        width: "128px"
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (PairPriceDisplay);


/***/ }),

/***/ 45131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ maxAmountSpend; }
/* harmony export */ });
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54346);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19838);


/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */ function maxAmountSpend(currencyAmount) {
    if (!currencyAmount) return undefined;
    if (currencyAmount.currency === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ETHER */ .c0) {
        if (_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.greaterThan */ .QA.greaterThan(currencyAmount.raw, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_BNB */ .Uz)) {
            return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.ether */ .ih.ether(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.subtract */ .QA.subtract(currencyAmount.raw, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_BNB */ .Uz));
        }
        return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.ether */ .ih.ether(config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .BIG_INT_ZERO */ .iV);
    }
    return currencyAmount;
}


/***/ }),

/***/ 90698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Chart_PriceChartContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(23917);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx + 29 modules
var Box = __webpack_require__(7180);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  border-radius: 6px;\n  width: 100%;\n  padding-top: 36px;\n  ",
        " {\n    padding-top: 8px;\n    background: ",
        ";\n    border: ",
        ";\n    border-radius: ",
        ";\n    width: ",
        ";\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledPriceChart = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-e8bcacf9-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var $isDark = param.$isDark;
    return $isDark ? "rgba(39, 38, 44, 0.5)" : "rgba(255, 255, 255, 0.5)";
}, function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.colors.cardBorder);
}, function(param) {
    var $isExpanded = param.$isExpanded;
    return $isExpanded ? "0" : "16px";
}, function(param) {
    var $isExpanded = param.$isExpanded, $isFullWidthContainer = param.$isFullWidthContainer;
    return $isFullWidthContainer || $isExpanded ? "100%" : "50%";
}, function(param) {
    var $isExpanded = param.$isExpanded;
    return $isExpanded ? "calc(100vh - 100px)" : "516px";
});
StyledPriceChart.defaultProps = {
    height: "70%"
};

;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/BnbWbnbNotice.tsx




var BnbWbnbNotice = function(param) {
    var isDark = param.isDark, isChartExpanded = param.isChartExpanded;
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPriceChart, {
        $isDark: isDark,
        $isExpanded: isChartExpanded,
        p: "24px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mb: [
                        "8px",
                        "8px",
                        "0px"
                    ],
                    textAlign: "center",
                    children: t("You can swap WPLS for PLS (and vice versa) with no trading fees.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mb: [
                        "8px",
                        "8px",
                        "0px"
                    ],
                    textAlign: "center",
                    children: t("Exchange rate is always 1 to 1.")
                })
            ]
        })
    });
};
/* harmony default export */ var Chart_BnbWbnbNotice = (BnbWbnbNotice);

// EXTERNAL MODULE: ./src/views/Swap/components/Chart/constants.ts
var constants = __webpack_require__(59298);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpointsContext.ts
var useMatchBreakpointsContext = __webpack_require__(98946);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/SyncAlt.tsx
var SyncAlt = __webpack_require__(29973);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/LineGraph.tsx
var LineGraph = __webpack_require__(40212);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Shrink.tsx
var Shrink = __webpack_require__(84482);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Expand.tsx
var Expand = __webpack_require__(90105);
// EXTERNAL MODULE: ./src/components/Logo/index.ts + 2 modules
var Logo = __webpack_require__(74314);
// EXTERNAL MODULE: ./src/state/user/actions.ts
var actions = __webpack_require__(46245);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(50156);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(39320);
// EXTERNAL MODULE: ./src/state/swap/hooks.ts + 13 modules
var swap_hooks = __webpack_require__(81081);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/NoChartAvailable.tsx



var NoChartAvailable = function(param) {
    var token0Address = param.token0Address, token1Address = param.token1Address, pairAddress = param.pairAddress, isMobile = param.isMobile;
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mb: [
                        "8px",
                        "8px",
                        "0px"
                    ],
                    children: t("Failed to load price chart for this pair")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    textAlign: isMobile ? "center" : "left",
                    mb: [
                        "8px",
                        "8px",
                        "0px"
                    ],
                    color: "textSubtle",
                    small: true,
                    style: isMobile && {
                        wordSpacing: "100vw"
                    },
                    children: [
                        "Token0: ",
                        token0Address !== null && token0Address !== void 0 ? token0Address : "null"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    textAlign: isMobile ? "center" : "left",
                    mb: [
                        "8px",
                        "8px",
                        "0px"
                    ],
                    color: "textSubtle",
                    small: true,
                    style: isMobile && {
                        wordSpacing: "100vw"
                    },
                    children: [
                        "Token1: ",
                        token1Address !== null && token1Address !== void 0 ? token1Address : "null"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    textAlign: isMobile ? "center" : "left",
                    mb: [
                        "8px",
                        "8px",
                        "0px"
                    ],
                    color: "textSubtle",
                    small: true,
                    style: isMobile && {
                        wordSpacing: "100vw"
                    },
                    children: [
                        "Pair: ",
                        pairAddress !== null && pairAddress !== void 0 ? pairAddress : "null"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Chart_NoChartAvailable = (NoChartAvailable);

// EXTERNAL MODULE: ./src/components/PairPriceDisplay.tsx
var PairPriceDisplay = __webpack_require__(98438);
// EXTERNAL MODULE: ./src/views/Swap/components/Chart/utils.ts
var utils = __webpack_require__(69197);
;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/BasicChart.tsx









var SwapLineChart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9782), __webpack_require__.e(6631), __webpack_require__.e(5488)]).then(__webpack_require__.bind(__webpack_require__, 31140));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31140)
            ];
        }
    },
    ssr: false
});
var BasicChart = function(param) {
    var token0Address = param.token0Address, token1Address = param.token1Address, isChartExpanded = param.isChartExpanded, inputCurrency = param.inputCurrency, outputCurrency = param.outputCurrency, isMobile = param.isMobile, currentSwapPrice = param.currentSwapPrice;
    var ref;
    var ref1 = (0,react.useState)(0), timeWindow = ref1[0], setTimeWindow = ref1[1];
    var ref2 = (0,swap_hooks/* useFetchPairPrices */.rH)({
        token0Address: token0Address,
        token1Address: token1Address,
        timeWindow: timeWindow,
        currentSwapPrice: currentSwapPrice
    }), _pairPrices = ref2.pairPrices, pairPrices = _pairPrices === void 0 ? [] : _pairPrices, pairId = ref2.pairId;
    var ref3 = (0,react.useState)(), hoverValue = ref3[0], setHoverValue = ref3[1];
    var ref4 = (0,react.useState)(), hoverDate = ref4[0], setHoverDate = ref4[1];
    var valueToDisplay = hoverValue || ((ref = pairPrices[pairPrices.length - 1]) === null || ref === void 0 ? void 0 : ref.value);
    var ref5 = (0,utils/* getTimeWindowChange */.E)(pairPrices), changePercentage = ref5.changePercentage, changeValue = ref5.changeValue;
    var isChangePositive = changeValue >= 0;
    var chartHeight = isChartExpanded ? "calc(100% - 120px)" : "378px";
    var ref6 = (0,Localization/* useTranslation */.$G)(), t = ref6.t, locale = ref6.currentLanguage.locale;
    var currentDate = new Date().toLocaleString(locale, {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    });
    // Sometimes we might receive array full of zeros for obscure tokens while trying to derive data
    // In that case chart is not useful to users
    var isBadData = pairPrices && pairPrices.length > 0 && pairPrices.every(function(price) {
        return !price.value || price.value === 0 || price.value === Infinity || Number.isNaN(price.value);
    });
    if (isBadData) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_NoChartAvailable, {
            token0Address: token0Address,
            token1Address: token1Address,
            pairAddress: pairId,
            isMobile: isMobile
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: [
                    "column",
                    null,
                    null,
                    null,
                    null,
                    null,
                    "row"
                ],
                alignItems: [
                    "flex-start",
                    null,
                    null,
                    null,
                    null,
                    null,
                    "center"
                ],
                justifyContent: "space-between",
                px: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        pt: "12px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PairPriceDisplay/* default */.Z, {
                                value: (pairPrices === null || pairPrices === void 0 ? void 0 : pairPrices.length) > 0 && valueToDisplay,
                                inputSymbol: inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol,
                                outputSymbol: outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: isChangePositive ? "success" : "failure",
                                    fontSize: "20px",
                                    ml: "4px",
                                    bold: true,
                                    children: "".concat(isChangePositive ? "+" : "").concat(changeValue.toFixed(3), " (").concat(changePercentage, "%)")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                small: true,
                                color: "secondary",
                                children: hoverDate || currentDate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonMenu/* default */.Z, {
                            activeIndex: timeWindow,
                            onItemClick: setTimeWindow,
                            scale: "sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                    children: t("24H")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                    children: t("1W")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                    children: t("1M")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                    children: t("1Y")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                height: isMobile ? "100%" : chartHeight,
                p: isMobile ? "0px" : "16px",
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapLineChart, {
                    data: pairPrices,
                    setHoverValue: setHoverValue,
                    setHoverDate: setHoverDate,
                    isChangePositive: isChangePositive,
                    timeWindow: timeWindow
                })
            })
        ]
    });
};
/* harmony default export */ var Chart_BasicChart = (/*#__PURE__*/(0,react.memo)(BasicChart, function(prev, next) {
    return prev.token0Address === next.token0Address && prev.token1Address === next.token1Address && prev.isChartExpanded === next.isChartExpanded && prev.isMobile === next.isMobile && prev.isChartExpanded === next.isChartExpanded && (prev.currentSwapPrice !== null && next.currentSwapPrice !== null && prev.currentSwapPrice[prev.token0Address] === next.currentSwapPrice[next.token0Address] && prev.currentSwapPrice[prev.token1Address] === next.currentSwapPrice[next.token1Address] || prev.currentSwapPrice === null && next.currentSwapPrice === null);
}));

;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/PriceChart.tsx


function PriceChart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 4px 8px;\n  border-radius: 6px;\n"
    ]);
    PriceChart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



// import { TradingViewLabel } from 'components/TradingView'






// import TradingViewChart from './TradingViewChart'
// import PairPriceDisplay from '../../../../components/PairPriceDisplay'
var ChartButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-85e3fd4c-0"
})(PriceChart_templateObject(), function(param) {
    var $active = param.$active, theme = param.theme;
    return $active && "".concat(theme.colors.primary, "0f");
});
var PriceChart = function(param) {
    var inputCurrency = param.inputCurrency, outputCurrency = param.outputCurrency, onSwitchTokens = param.onSwitchTokens, isDark = param.isDark, isChartExpanded = param.isChartExpanded, setIsChartExpanded = param.setIsChartExpanded, isMobile = param.isMobile, isFullWidthContainer = param.isFullWidthContainer, token0Address = param.token0Address, token1Address = param.token1Address, currentSwapPrice = param.currentSwapPrice;
    var isDesktop = (0,useMatchBreakpointsContext/* default */.Z)().isDesktop;
    var toggleExpanded = function() {
        return setIsChartExpanded(function(currentIsExpanded) {
            return !currentIsExpanded;
        });
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useExchangeChartViewManager */.OE)(), 2), chartView = ref[0], setChartView = ref[1];
    // const [twChartSymbol, setTwChartSymbol] = useState('')
    var t = (0,Localization/* useTranslation */.$G)().t;
    // const handleTwChartSymbol = useCallback((symbol) => {
    //   setTwChartSymbol(symbol)
    // }, [])
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPriceChart, {
        height: chartView === actions/* ChartViewMode.TRADING_VIEW */.UU.TRADING_VIEW ? "100%" : "70%",
        overflow: chartView === actions/* ChartViewMode.TRADING_VIEW */.UU.TRADING_VIEW ? "hidden" : "unset",
        $isDark: isDark,
        $isExpanded: isChartExpanded,
        $isFullWidthContainer: isFullWidthContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                px: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            outputCurrency ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* DoubleCurrencyLogo */.ge, {
                                currency0: inputCurrency,
                                currency1: outputCurrency,
                                size: 24,
                                margin: true
                            }) : inputCurrency && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                currency: inputCurrency,
                                size: "24px",
                                style: {
                                    marginRight: "8px"
                                }
                            }),
                            inputCurrency && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "text",
                                bold: true,
                                children: outputCurrency ? "".concat(inputCurrency.symbol, "/").concat(outputCurrency.symbol) : inputCurrency.symbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                variant: "text",
                                onClick: onSwitchTokens,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SyncAlt/* default */.Z, {
                                    ml: "6px",
                                    color: "primary"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartButton, {
                                    "aria-label": t("Basic"),
                                    title: t("Basic"),
                                    $active: chartView === actions/* ChartViewMode.BASIC */.UU.BASIC,
                                    scale: "sm",
                                    variant: "text",
                                    color: "primary",
                                    onClick: function() {
                                        return setChartView(actions/* ChartViewMode.BASIC */.UU.BASIC);
                                    },
                                    mr: "8px",
                                    children: isDesktop ? t("Basic") : /*#__PURE__*/ (0,jsx_runtime.jsx)(LineGraph/* default */.Z, {
                                        color: "primary"
                                    })
                                })
                            })
                        ]
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            variant: "text",
                            onClick: toggleExpanded,
                            children: isChartExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Shrink/* default */.Z, {
                                color: "text"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Expand/* default */.Z, {
                                color: "text"
                            })
                        })
                    })
                ]
            }),
            chartView === actions/* ChartViewMode.BASIC */.UU.BASIC && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_BasicChart, {
                token0Address: token0Address,
                token1Address: token1Address,
                isChartExpanded: isChartExpanded,
                inputCurrency: inputCurrency,
                outputCurrency: outputCurrency,
                isMobile: isMobile,
                currentSwapPrice: currentSwapPrice
            })
        ]
    });
};
/* harmony default export */ var Chart_PriceChart = (PriceChart);

;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/PriceChartContainer.tsx







var PriceChartContainer = function(param) {
    var inputCurrencyId = param.inputCurrencyId, inputCurrency = param.inputCurrency, outputCurrency = param.outputCurrency, outputCurrencyId = param.outputCurrencyId, isChartExpanded = param.isChartExpanded, setIsChartExpanded = param.setIsChartExpanded, isChartDisplayed = param.isChartDisplayed, isMobile = param.isMobile, _isFullWidthContainer = param.isFullWidthContainer, isFullWidthContainer = _isFullWidthContainer === void 0 ? false : _isFullWidthContainer, currentSwapPrice = param.currentSwapPrice;
    var token0Address = (0,utils/* getTokenAddress */.D)(inputCurrencyId);
    var token1Address = (0,utils/* getTokenAddress */.D)(outputCurrencyId);
    var ref = (0,react.useState)(false), isPairReversed = ref[0], setIsPairReversed = ref[1];
    var togglePairReversed = (0,react.useCallback)(function() {
        return setIsPairReversed(function(prePairReversed) {
            return !prePairReversed;
        });
    }, []);
    var isDark = (0,useTheme/* default */.ZP)().isDark;
    if (!isChartDisplayed) {
        return null;
    }
    var isBnbWbnb = token0Address === constants/* BNB_ADDRESS */.I && token1Address === constants/* BNB_ADDRESS */.I;
    if (isBnbWbnb) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_BnbWbnbNotice, {
            isDark: isDark,
            isChartExpanded: isChartExpanded
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_PriceChart, {
        token0Address: isPairReversed ? token1Address : token0Address,
        token1Address: isPairReversed ? token0Address : token1Address,
        inputCurrency: isPairReversed ? outputCurrency : inputCurrency,
        outputCurrency: isPairReversed ? inputCurrency : outputCurrency,
        onSwitchTokens: togglePairReversed,
        isDark: isDark,
        isChartExpanded: isChartExpanded,
        setIsChartExpanded: setIsChartExpanded,
        isMobile: isMobile,
        isFullWidthContainer: isFullWidthContainer,
        currentSwapPrice: currentSwapPrice
    });
};
/* harmony default export */ var Chart_PriceChartContainer = (PriceChartContainer);


/***/ })

}]);